import { render, staticRenderFns } from "./SelectAndLabel.vue?vue&type=template&id=1ce01990&scoped=true&"
import script from "./SelectAndLabel.vue?vue&type=script&lang=js&"
export * from "./SelectAndLabel.vue?vue&type=script&lang=js&"
import style0 from "./SelectAndLabel.vue?vue&type=style&index=0&id=1ce01990&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce01990",
  null
  
)

export default component.exports